/**
 * The editor toolboxes english translations
 */
export const EDITOR_TOOL_BOX_GENERATE_COMPONENT_EN = {
  generate: 'Generate',
  restart: 'Restart',
  loading: 'Loading...',
  similarities: 'Similarities',
  moreTitles: 'More Titles',
  generateBannerImage: 'Generate Banner Image',
  regenerateBannerImage: 'Regenerate Banner Image',
  generatingBannerImage: 'Generating Banner...',
  bannerImageFocus: 'Banner Focus',
  adjustBannerImageFocus: 'Adjust Banner Crop',
  dragBannerImageFocusHint: 'Drag the image to choose which area stays inside the banner.',
  bannerImageFocusNotAdjustable:
    'This image already fits the banner height. No vertical crop needed.',
  cancelBannerImageCrop: 'Cancel',
  confirmBannerImageCrop: 'Apply Crop',
  bannerImageGenerated: 'Banner image generated successfully',
  errorGeneratingBannerImage: 'Could not generate banner image.',
  comingSoon: 'Coming Soon!',
  editorToolBox: 'Toolbox',
  original: 'Original',
  linkDialog: {
    editLink: 'Edit Link',
    insertLink: 'Insert Link',
    updateDescription: 'Update the link URL below.',
    insertDescription: 'Enter a URL to create a link.',
    urlLabel: 'URL',
    urlPlaceholder: 'https://example.com',
    invalidUrl: 'Please enter a valid URL',
    removeLink: 'Remove Link',
    cancel: 'Cancel',
    update: 'Update',
    insert: 'Insert'
  }
}

/**
 * The editor toolboxes german translation
 */
export const EDITOR_TOOL_BOX_GENERATE_COMPONENT_DE = {
  generate: 'Generieren!',
  restart: 'Neu starten',
  loading: 'Lade...',
  similarities: 'Ähnlichkeiten',
  moreTitles: 'Mehr Titel',
  generateBannerImage: 'Bannerbild generieren',
  regenerateBannerImage: 'Bannerbild neu generieren',
  generatingBannerImage: 'Bannerbild wird generiert...',
  bannerImageFocus: 'Bannerfokus',
  adjustBannerImageFocus: 'Bannerausschnitt anpassen',
  dragBannerImageFocusHint: 'Ziehe das Bild, um den sichtbaren Bereich im Banner festzulegen.',
  bannerImageFocusNotAdjustable:
    'Dieses Bild passt bereits vollständig in die Bannerhöhe. Kein vertikaler Beschnitt nötig.',
  cancelBannerImageCrop: 'Abbrechen',
  confirmBannerImageCrop: 'Ausschnitt anwenden',
  bannerImageGenerated: 'Bannerbild erfolgreich generiert',
  errorGeneratingBannerImage: 'Bannerbild konnte nicht generiert werden.',
  comingSoon: 'Bald verfügbar!',
  editorToolBox: 'Toolbox',
  original: 'Original',
  linkDialog: {
    editLink: 'Link bearbeiten',
    insertLink: 'Link einfügen',
    updateDescription: 'Aktualisieren Sie die Link-URL unten.',
    insertDescription: 'Geben Sie eine URL ein, um einen Link zu erstellen.',
    urlLabel: 'URL',
    urlPlaceholder: 'https://beispiel.de',
    invalidUrl: 'Bitte geben Sie eine gültige URL ein',
    removeLink: 'Link entfernen',
    cancel: 'Abbrechen',
    update: 'Aktualisieren',
    insert: 'Einfügen'
  }
}
